import { SETTINGS } from '../../../utils/constants';
import { View } from '../../base/View';
export class SuccessView extends View {
    constructor(container, actions) {
        super(container);
        this._description = container.querySelector(SETTINGS.successSettings.description);
        this._button = container.querySelector(SETTINGS.successSettings.button);
        if (actions === null || actions === void 0 ? void 0 : actions.onClick)
            this._button.addEventListener('click', actions.onClick);
    }
    set description(price) {
        this._description.textContent = `Списано ${price} синапсов`;
    }
}
